<script setup>
import { CardsStats } from "@easy/ui/cards";
import { computed, onMounted, ref } from "vue";
import { playerStatsService } from "@/apps/player/services/player-stats.service";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { FilterList } from "@easy/ui/filters";
import { i18n } from "@/i18n";
import { statFactory } from "@/apps/player/panel/stat-factory";

const { t } = useI18n();
const { params } = useRoute();
const playerUUID = computed(() => params.projectUuid);
const stats = ref([]);
const lang = ref(i18n.global.locale.value);
const filtersData = [
    {
        name: "calendar",
        label: t("shared.filters.dates"),
        value: "all",
        options: [
            { label: t("shared.filters.date.custom"), value: "custom" },
            { label: t("shared.filters.date.all"), value: "all" },
            { label: t("shared.filters.date.today"), value: "today" },
            { label: t("shared.filters.date.last7days"), value: "last7days" },
            { label: t("shared.filters.date.last14days"), value: "last14days" },
            { label: t("shared.filters.date.last30days"), value: "last30days" },
            { label: t("shared.filters.date.last3months"), value: "last3months" },
            { label: t("shared.filters.date.last12months"), value: "last12months" },
        ],
        type: "calendar",
        startDate: new Date(),
        endDate: new Date(),
    },
    {
        name: "perPage",
        label: t("shared.filters.per_page"),
        value: "20",
        options: [
            { label: "10", value: "10" },
            { label: "20", value: "20" },
            { label: "50", value: "50" },
            { label: "100", value: "100" },
        ],
    },
];
const applyFilter = (filter) => {
    console.log("applyFilter", filter);
};
const applyCustomFilter = (filter) => {
    console.log("applyCustomFilter", filter);
};

onMounted(async () => {
    try {
        const generalStats = await playerStatsService.getSummaryForLessons(playerUUID.value);
        stats.value = [
            statFactory(t("player.panel.stats.lessons"), generalStats?.numberOfLessons),
            statFactory(t("player.panel.stats.finished"), generalStats?.numberOfDoneLessons),
            statFactory(t("player.panel.stats.progress"), generalStats?.averageLessonProgress, {
                decorateWith: "%",
            }),
        ];
    } catch (e) {
        console.error(e);
    }
});
</script>

<template>
    <div class="flex flex-col">
        <div
            v-if="false"
            class="order-1 lg:order-0 flex items-center lg:py-3 lg:px-6 lg:space-x-6 border-b ct-border-2"
        >
            <div class="flex-grow">
                <FilterList
                    :filters="filtersData"
                    :lang="lang"
                    :label="$t('shared.filters.title')"
                    @select="applyFilter"
                    @selectCustom="applyCustomFilter"
                />
            </div>
        </div>
        <CardsStats :stats="stats" class="order-0 lg:order-1 border-b ct-border-2" />
    </div>
</template>
